'use strict';
const a = (t, o) => Math.round(t + t * (o / 100));
function s(t, o = 2) {
  if (!+t) return "0 Bytes";
  const n = 1024, B = o < 0 ? 0 : o, e = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"], r = Math.floor(Math.log(t) / Math.log(n));
  return `${parseFloat((t / Math.pow(n, r)).toFixed(B))} ${e[r]}`;
}
export {
  a as addPercentage,
  s as formatBytes
};
